import Page from './Page';

export default Page;
export { default as Grid } from './Grid';
export { default as GridColumn } from './GridColumn';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@atlaskit/page/dist/esm/index.js
// module id = 266
// module chunks = 0